import dynamic from 'next/dynamic'
import { customerId } from '@/utils/env'
import { withLogger } from '@/utils/logger'
import apiWrapper from '@/utils/apiHelpers/apiWrapper'
import { customerHelper } from '@tweddle-se-team/common/constants'
import { reduxWrapper } from '@/store'
import headerHelper from '@/store/helpers/headerHelper'
import { pageActions } from '@/store/page'
import { getInitialStoreSetup } from '@/store/helpers/storeHelpers'

const { PUBLICATION_RETRIEVAL_CRITERIA } = customerHelper

const PDFPage = dynamic(() => import('@/components/pdf/pdfPage'), { ssr: false })

export const customServerSideProps = async (ctx, store, options = {}) => {
  const { params, query } = ctx
  const { partNumber } = params
  const criteriaFields = PUBLICATION_RETRIEVAL_CRITERIA[customerId] || PUBLICATION_RETRIEVAL_CRITERIA['TME']
  const criteria = { partNumber }
  await getInitialStoreSetup({ store, ctx })

  for (const field of criteriaFields) {
    if (query[field] !== undefined) {
      criteria[field] = query[field]
    }
  }

  if (options.publicationState) {
    criteria.publicationState = options.publicationState
  }

  const { page } = query
  const showTranslationUnderDevelopment = query.swTranslationUnderDevelopment === 'true'

  try {
    const pdfResult = await apiWrapper.get(`publications/content/pdfLink`, criteria)
    const { url, publication } = pdfResult

    if (publication) {
      const { brand, model, modelType, year, language } = publication
      await headerHelper.setHeaderModel(store, { brand, model, modelType, year, language })
      await store.dispatch(pageActions.SET_TITLE(`${year} ${model} ${modelType}`))
      return {
        props: {
          pdfUrl: url,
          partNumber,
          page: page ? Number(page) : 1,
          publication,
          showTranslationUnderDevelopment,
          ...(options.isPreview && { isPreviewMode: true })
        }
      }
    } else {
      return {
        notFound: true
      }
    }
  } catch (error) {
    if (error.status === 404) {
      return {
        notFound: true
      }
    }
    throw error
  }
}

export const getServerSideProps = reduxWrapper.getServerSideProps(store =>
  withLogger(ctx => customServerSideProps(ctx, store))
)

export default PDFPage
